__turbopack_context__.v({
  "className": "anuphan_e946e3e1-module__oJ3ORW__className",
  "variable": "anuphan_e946e3e1-module__oJ3ORW__variable",
});
